import { memo } from 'react';

function NotCompletedMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.39001 12C9.39001 13.1046 8.49458 14 7.39001 14C6.28545 14 5.39001 13.1046 5.39001 12C5.39001 10.8954 6.28545 10 7.39001 10C8.49458 10 9.39001 10.8954 9.39001 12ZM14.39 12C14.39 13.1046 13.4946 14 12.39 14C11.2854 14 10.39 13.1046 10.39 12C10.39 10.8954 11.2854 10 12.39 10C13.4946 10 14.39 10.8954 14.39 12ZM17.39 14C18.4946 14 19.39 13.1046 19.39 12C19.39 10.8954 18.4946 10 17.39 10C16.2854 10 15.39 10.8954 15.39 12C15.39 13.1046 16.2854 14 17.39 14Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(NotCompletedMarker);
